import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { HR } from 'foundations-components/transitional/components/HR';
import { Small } from 'foundations-components/transitional/components/Small';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import FormattedMessage from 'I18n/components/FormattedMessage';
import formatName from 'I18n/utils/formatName';
import unescapedText from 'I18n/utils/unescapedText';
import { useUsers } from '../hooks/useUsers';
import { useAvatars } from '../hooks/useAvatars';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAX_MESSAGE_LENGTH = 200;
function ApprovalStep({
  approvalInfo,
  approvalScope,
  usersToNotifyForExportApproval,
  exportApprovalRequestMessage,
  setUsersToNotifyForExportApproval,
  setExportApprovalRequestMessage
}) {
  const {
    data: users
  } = useUsers({
    scope: approvalScope
  });
  const {
    data: avatars
  } = useAvatars({
    emails: users.map(user => user.email)
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.approvalStep.approvalStepLabel"
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "exportDialog.approvalStep.approvalStepDescription"
        })
      })
    }), approvalInfo, /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.approvalStep.approvalStepApproversToNotify"
      }),
      children: /*#__PURE__*/_jsx(Select, {
        multi: true,
        value: usersToNotifyForExportApproval,
        onChange: ({
          target: {
            value
          }
        }) => setUsersToNotifyForExportApproval(value),
        options: users.map(user => {
          var _avatars$hubSpotUserE;
          return {
            text: formatName({
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email
            }),
            value: String(user.id),
            imageUrl: (_avatars$hubSpotUserE = avatars.hubSpotUserEmails) === null || _avatars$hubSpotUserE === void 0 || (_avatars$hubSpotUserE = _avatars$hubSpotUserE[user.email]) === null || _avatars$hubSpotUserE === void 0 ? void 0 : _avatars$hubSpotUserE.uri
          };
        }),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "exportDialog.approvalStep.approvalStepApproversSelect"
        })
      })
    }), /*#__PURE__*/_jsx(CharacterCounter, {
      value: exportApprovalRequestMessage,
      onChange: ({
        target: {
          value
        }
      }) => setExportApprovalRequestMessage(value),
      counter: "down",
      max: MAX_MESSAGE_LENGTH,
      renderInput: ({
        count,
        onChange,
        value
      }) => /*#__PURE__*/_jsx(FormControl, {
        characterCount: count,
        error: count < 0,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "exportDialog.approvalStep.approvalStepMessageLabel"
        }),
        children: /*#__PURE__*/_jsx(TextArea, {
          disabled: usersToNotifyForExportApproval.length === 0,
          onChange: onChange,
          defaultValue: value,
          placeholder: unescapedText('exportDialog.approvalStep.approvalStepMessagePlaceholder')
        })
      })
    })]
  });
}
export default ApprovalStep;